// TEMP : should be rollback to previous version
const IS_DEV = import.meta.env.DEV;
const VERSION = IS_DEV ? 'N/A' : '4.6.0';

export { VERSION, IS_DEV };
